class QuestionSlider extends BD_Question {
	constructor(...args) {
		super(...args);
	}

	getAnswer(ctx) {
		const index = parseInt($(".slider__item").val());
		const answer = ctx._data.question.answers[index];
		return answer.id;
	}
}
